import { render, staticRenderFns } from "./CustmerBind.vue?vue&type=template&id=51fc0d67"
import script from "./CustmerBind.vue?vue&type=script&lang=js"
export * from "./CustmerBind.vue?vue&type=script&lang=js"
import style0 from "./CustmerBind.vue?vue&type=style&index=0&id=51fc0d67&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports